import styled from 'styled-components';

const FormWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
  padding: 20px 24px;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: row;
  height: 450px;
`;

const SidebarHeader = styled.div`
  border-bottom: 1px solid var(--greyscale-dark-white);
  color: var(--greyscale-blackish);
  font-size: var(--font-size-medium);
  font-weight: var(--font-weight-medium);
  padding: 14px 20px;
`;

const SidebarItem = styled.div`
  cursor: pointer;

  &:not(:last-child) {
    border-bottom: 1px solid var(--greyscale-dark-white);
  }
`;

const SidebarItemApply = styled.button`
  background: none;
  border: none;
  color: var(--primary-oqio-blue);
  cursor: pointer;
  display: inline-flex;
  font-size: var(--font-size-regular);
  gap: 6px;
  padding: 0;

  svg {
    height: 18px;
    margin-top: 1px;
    width: 18px;
  }
`;

const SidebarItemBody = styled.div`
  background: var(--greyscale-porcelain);
  padding: 10px 20px 14px;
`;

const SidebarItemHeader = styled.div`
  color: var(--greyscale-blackish);
  font-size: var(--font-size-regular);
  font-weight: ${({ $active }) => ($active ? 'var(--font-weight-medium)' : 'var(--font-weight-regular)')};
  padding: 10px 20px;
`;

const SidebarItemText = styled.p`
  color: var(--greyscale-shade);
  font-size: var(--font-size-regular);
  margin: 0 0 10px;
`;

const SidebarList = styled.div`
  overflow-y: auto;
  scrollbar-color: rgb(136 136 136 / 30%) transparent;
  scrollbar-width: thin;
`;

const SidebarWrapper = styled.div`
  border-right: 1px solid var(--greyscale-dark-white);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 380px;
`;

const TemplateModalLayout = {
  FormWrapper,
  ModalBody,
  SidebarHeader,
  SidebarItem,
  SidebarItemApply,
  SidebarItemBody,
  SidebarItemHeader,
  SidebarItemText,
  SidebarList,
  SidebarWrapper
};

export default TemplateModalLayout;
